<div class="modal-header">
    <h4 class="modal-title">{{data.number == 1 ? 'Firma Hareketi' : 'Hesap Hareketi'}} Ekle</h4>
</div>
<div class="modal-body">
    <form [formGroup]="vaultForm">
        <div class="col-12" *ngIf="data.number == 2 && data.manuelBalanceMovement == true">
            <label>Transfer hesabı seçin</label>
            <div class="form-group">
                <ng-select [items]="vaults" bindLabel="title" formControlName="vault">
                </ng-select>
                <div *ngIf="vaultForm.get('kind').invalid && vaultForm.get('kind').touched" class="text-danger">
                    İşlem Türü zorunludur.
                </div>
            </div>
        </div>
        <div class="col-12" *ngIf="data.number == 1">
            <label>Firma Seçin</label>
            <div class="form-group">
                <ng-select [items]="companies" bindLabel="companyName" formControlName="company">
                </ng-select>
                <div *ngIf="vaultForm.get('kind').invalid && vaultForm.get('kind').touched" class="text-danger">
                    Firma zorunludur.
                </div>
            </div>
        </div>
        <div class="col-12">
            <label>İşlem Türü</label>
            <div class="form-group">
                <ng-select [items]="kinds" bindLabel="typeName" formControlName="kind">
                </ng-select>
                <div *ngIf="vaultForm.get('kind').invalid && vaultForm.get('kind').touched" class="text-danger">
                    İşlem Türü zorunludur.
                </div>
            </div>
        </div>
        <div class="col-12" *ngIf="data.number == 2">
            <label for="salaryPaymentDate">İşlem Tarihi</label>
            <div class="form-group">
                <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" formControlName="vaultDate"
                    [setDate]="date"></ng2-flatpickr>
            </div>
        </div>
        <div class="col-12">
            <label for="title">Tutar</label>
            <div class="form-group">
                <div class="input-group">
                    <input type="number" class="form-control" id="balance" formControlName="balance" />
                </div>
                <div *ngIf="vaultForm.get('balance').invalid && vaultForm.get('balance').touched" class="text-danger">
                    Tutar zorunludur.
                </div>
            </div>
        </div>
        <div class="col-12">
            <label for="description">Açıklama</label>
            <div class="form-group">
                <div class="input-group">
                    <textarea class="form-control" id="description" formControlName="description"></textarea>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="vaultForm.invalid" (click)="save()">
        Kaydet
    </button> <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
</div>